import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'

import { getAlgoliaDataQueryId } from 'selectors/algolia2/data'

const mapStateToProps = createStructuredSelector({
  queryID: getAlgoliaDataQueryId,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  queryID: string
}

export default connect(mapStateToProps, mapDispatchToProps)
